module.exports = __webpack_public_path__ + "img/ink_phone_x.b820729a.png";